import { gql } from '@apollo/client';

export const GET_ALL_QUERY_RETURNS = gql`
query GET_ALL_QUERY_RETURNS($originatorId: ID!, $officerId: ID!, $perPage: Int, $page: Int) {
  queryReturns(originatorId: $originatorId, officerId: $officerId, perPage: $perPage, page: $page) {
    id
    exchangeId
    incident {
      id
      incidentNumber
      locked
      sealed
    }
    mke
    officer {
      id
      deptAttribute {
        badge
        ori {
          abbreviation
        }
      }
    }
    read
    returnObj
    returnText
    source
    updatedIncident
    createdAt
  }
}
`

  
// query GET_INITIAL_CALL_INFO($incidentId: ID!, $originatorId: ID!){
  //   initialCallInfo(incidentId: $incidentId, originatorId: $originatorId) {
  //     __typename
  //     id
  //     queryReturns
  //   }    
  // }